export const QUALITY_THUMBNAIL = "thumbnail";
export const QUALITY_LOW = "low_quality";
export const QUALITY_HIGH = "high_quality";
export const QUALITY_ORIGINAL = "original";
export const QUALITY_AUTO = "auto";

export const IMAGE_QUALITY_LEVELS = [
  QUALITY_THUMBNAIL,
  QUALITY_LOW,
  QUALITY_HIGH,
  QUALITY_ORIGINAL,
];
